import axios from 'axios';

export async function downloadTemplate() {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/bulk_download_file`;
  let result = '';
  await axios
    .get(url)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('deactivate self account java api error', err);
    });
  return result;
}

export async function getInvalidRecords(data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/bulk_upload`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('Get registration details of invalid records by pagination JAVA api error', err);
    });
  return result;
}

/* user upload delete API
 * to upload the template */
export async function uploadTemplete(formData) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/bulk_upload_file`;
  let result = '';
  await axios
    .post(url, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('upload template user java api error', err.response.data); // eslint-disable-line no-console
      result = err.response.data;
    });
  return result;
}

/* invalid record  delete API
 * to delete  invalid record */
export async function deleteRecord(data) {
  let result = '';
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/bulk_delete`, { data })
    .then((response) => {
      if (response.status === 204) result = response;
    }).catch((err) => {
      console.log('delete invalid record java api error', err); // eslint-disable-line no-console
    });
  return result;
}
